import { error } from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const getActivatedOffers = gql`
  query GetActivatedOffers {
    myPartnerOffers {
      myOffersComponent {
        ... on MyOffersComponentSuccess {
          __typename
          myOffersComponent {
            bodyItems {
              title
              onActivateAnalytics {
                ...AnalyticsEventFragment
              }
              iconUrl
              id
            }
            id
            subTitle
            title
          }
          displayAnalytics {
            name
            properties {
              key
              value
            }
          }
          id
          onClick {
            analyticsEvent {
              name
              properties {
                key
                value
              }
            }
            route
          }
        }
        ... on MyOffersComponentError {
          __typename
          ...error
        }
      }
    }
  }
  ${error}
  ${AnalyticsEventFragment}
`;

export default getActivatedOffers;
